module.exports = "/_next/static/images/GearlessM-5551c2824b9d9b1bc8a7a22760d5aef5.png";